import { render } from "./AddUserNew.vue?vue&type=template&id=67419120&scoped=true"
import script from "./AddUserNew.vue?vue&type=script&lang=js"
export * from "./AddUserNew.vue?vue&type=script&lang=js"

import "./AddUserNew.vue?vue&type=style&index=0&id=67419120&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67419120"]])

export default __exports__